import { render } from "./EditBankAccount.vue?vue&type=template&id=7a18853e"
import script from "./EditBankAccount.vue?vue&type=script&lang=js"
export * from "./EditBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__